import React from 'react'
import PropTypes from 'prop-types'
import { Row, Column } from '@sainsburys-tech/bolt'
import { ComponentHelper } from '../../../helpers/ComponentHelper'
import { GetComponent } from '../../CMSComponents'

/**
 * - GL006 splits the rows in a mixture of 2/3 - 1/3 sections,
 * with alternating orientation, which can be used to slot in the components.
 * - It allows the authors to also add a heading above it.
 * - It's primarily used on Argos on the Browse pages.
 */

const GL006 = ({ included, heading, categoryId, onLinkClick }) => {
  const validLength = 2
  if (included.length <= validLength) return null
  return (
    <div data-test='gl006-container'>
      {heading && <h2 data-test='gl006-heading'>{heading}</h2>}
      <Row data-test='gl006-components-container' row='xs' negative='xs' xs={12} gutterSize='15px'>
        {included.map((component, index) => {
          const visualSize = ComponentHelper.gridLayout('GL006', index, included.length)
          const visualDesktopSize = ComponentHelper.gridLayout('GL006-lg', index, included.length)
          const gridProps = { categoryId, visualSize, visualDesktopSize, onLinkClick }
          return (
            <Column
              gutterValue={1}
              xs={visualSize}
              md={visualDesktopSize}
              data-test={`gl006-component-container-${index}`}
              key={`gl006-key-${index}`}
            >
              <GetComponent {...{ ...component, ...gridProps }} />
            </Column>
          )
        })}
      </Row>
    </div>
  )
}

GL006.propTypes = {
  /** Fed by CMS, defines the CLP the grid's placed on */
  categoryId: PropTypes.string,
  /** Optional heading to describe the browse catagories displayed in the grid */
  heading: PropTypes.string,
  /** Array of child components to be rendered inside the grid */
  included: PropTypes.arrayOf(PropTypes.shape).isRequired,
  /** Optional function passed down to child components */
  onLinkClick: PropTypes.func
}

GL006.defaultProps = {
  categoryId: '',
  heading: '',
  onLinkClick: null
}

export default GL006
